export const UserStatus = {
  draft: 'Draft',
  invited: 'Invited',
  accepted: 'Accepted',
  kycNotStarted: 'KYC Not Started',
  kycSubmitted: 'KYC Submitted',
  kycInReview: 'KYC In Review',
  kycApproved: 'KYC Approved',
  kycDeclined: 'KYC Declined',
  idvNotStarted: 'IDV Not Started',
  idvSubmitted: 'IDV Submitted',
  idvInReview: 'IDV In Review',
  idvApproved: 'IDV Approved',
  idvDeclined: 'IDV Declined',
  active: 'Active',
  accountCreationFailed: 'Account Creation Failed',
  accountProcessing: 'Account Processing',
};

export enum USER_STATUS {
  draft = 'draft',
  invited = 'invited',
  accepted = 'accepted',
  // TODO: Remove legacy statuses
  kycNotStarted = 'kycNotStarted',
  kycSubmitted = 'kycSubmitted',
  kycInReview = 'kycInReview',
  kycApproved = 'kycApproved',
  kycDeclined = 'kycDeclined',
  idvNotStarted = 'idvNotStarted',
  idvSubmitted = 'idvSubmitted',
  idvInReview = 'idvInReview',
  idvApproved = 'idvApproved',
  idvDeclined = 'idvDeclined',
  active = 'active',
  accountCreationFailed = 'accountCreationFailed',
  accountProcessing = 'accountProcessing',
}

export const ACCEPTED_AND_HIGHT_STATUSES: string[] = [
  USER_STATUS.accepted,
  USER_STATUS.active,
  USER_STATUS.accountProcessing,
  USER_STATUS.accountCreationFailed,
];
